import { motion } from "framer-motion";
import { Users, Leaf, ShieldCheck, BadgePoundSterling } from "lucide-react";

const items = [
  { icon: Users, title: "Friendly, experienced team", desc: "Local people who take pride in every job, big or small." },
  { icon: Leaf, title: "Eco-conscious approach", desc: "Considerate methods that care for your grounds and the environment." },
  { icon: ShieldCheck, title: "Fully insured", desc: "Complete peace of mind on every visit, for homes and businesses." },
  { icon: BadgePoundSterling, title: "Competitive pricing", desc: "Honest, fair quotes with no hidden extras — great value all round." },
];

const reveal = {
  hidden: { opacity: 0, y: 40 },
  show: { opacity: 1, y: 0, transition: { duration: 0.7, ease: [0.22, 1, 0.36, 1] } },
};

export const WhyChooseUs = () => {
  return (
    <section id="why" className="relative bg-brand-surface py-24 md:py-32">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-start">
          <motion.div
            variants={reveal}
            initial="hidden"
            whileInView="show"
            viewport={{ once: true, margin: "-80px" }}
            className="lg:col-span-4"
          >
            <div className="flex items-center gap-3 mb-6">
              <span className="h-px w-12 bg-brand-orange" />
              <span className="text-xs md:text-sm tracking-[0.25em] uppercase font-heading text-brand-orange">
                Why choose us
              </span>
            </div>
            <h2 className="font-heading font-medium tracking-tight text-white text-4xl md:text-5xl leading-[1.05]">
              Ground care done the right way.
            </h2>
            <p className="text-white/60 font-body mt-6 leading-relaxed">
              High-quality ground maintenance for homes, businesses and public open spaces —
              clean, healthy and professionally maintained, all year round.
            </p>
          </motion.div>

          <div className="lg:col-span-8 grid grid-cols-1 sm:grid-cols-2 gap-px bg-white/10 border border-white/10">
            {items.map((it, i) => (
              <motion.div
                key={it.title}
                data-testid={`why-item-${i}`}
                variants={reveal}
                initial="hidden"
                whileInView="show"
                viewport={{ once: true, margin: "-40px" }}
                transition={{ delay: i * 0.06 }}
                className="group bg-brand-ink p-8 md:p-10 hover:bg-brand-elevated transition-colors"
              >
                <span className="inline-flex w-12 h-12 items-center justify-center border border-white/15 group-hover:border-brand-orange group-hover:bg-brand-orange transition-colors mb-5">
                  <it.icon size={22} className="text-brand-orange group-hover:text-white transition-colors" />
                </span>
                <h3 className="font-heading text-white text-xl mb-2">{it.title}</h3>
                <p className="text-white/60 font-body">{it.desc}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
